/** Money is paise (integers) everywhere; shown as ₹ with 2 decimals, Indian grouping. */
const inr = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatINR(paise: number | null | undefined): string {
  const p = Number(paise || 0);
  const sign = p < 0 ? '-' : '';
  return `${sign}₹${inr.format(Math.abs(p) / 100)}`;
}

/** "1,234.5" / "₹99" -> paise; null when not a valid amount. */
export function rupeesToPaise(text: string | number): number | null {
  const s = String(text).replace(/[₹,\s]/g, '');
  if (s === '' || !/^\d*(\.\d{0,2})?$/.test(s)) return null;
  const [r, f = ''] = s.split('.');
  return Number(r || 0) * 100 + Number((f + '00').slice(0, 2));
}

export function paiseToRupeesInput(paise: number | null | undefined): string {
  if (paise == null) return '';
  return (paise / 100).toFixed(2).replace(/\.00$/, '');
}

/** Quantities: whole numbers without decimals, weighed up to 3 places. */
export function formatQty(qty: number): string {
  return Number.isInteger(qty) ? String(qty) : qty.toFixed(3).replace(/0+$/, '');
}

/** Tax contained in a tax-inclusive amount (same rounding as the server). */
export function includedTax(amountPaise: number, gstPercent: number): number {
  const bp = Math.round(gstPercent * 100);
  if (bp <= 0) return 0;
  return Math.round((amountPaise * bp) / (10000 + bp));
}

/** Cases + loose units, e.g. 29 bottles with 12 per case -> "2 case + 5". */
export function packBreakdown(qty: number, packSize: number | null | undefined, packUnit = 'case'): string {
  if (!packSize || packSize <= 1 || qty < packSize) return formatQty(qty);
  const packs = Math.floor(qty / packSize);
  const loose = qty - packs * packSize;
  return `${packs} ${packUnit}${loose ? ` + ${formatQty(loose)}` : ''}`;
}
